export default __webpack_public_path__ + "static/media/HackPlus-dark.5b8390a6.svg";